import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TransactionsService } from "src/app/api/transactions.service";
import { AppSettings } from "src/app/app-settings";

@Component({
  selector: "app-search",
  templateUrl: "./search.page.html",
  styleUrls: ["./search.page.scss"],
})
export class SearchPage {
  @Input() filters: object;

  @Input() isHistory: boolean;

  public types: string[] = ["ANY", "WTB", "RFQ"];
  public selectedType: string;

  public reference: string;

  public conditions: string[] = ["ANY", "REF", "NOB", "NEW", "AS IS", "USED"];
  public selectedCondition: string;

  private periods = new Map<String, String>();

  public selectedPeriod: String;

  public periodKeys: String[];

  isWeb = AppSettings.IS_WEB;

  constructor(
    private modalCtrl: ModalController,
    private transactionsService: TransactionsService
  ) {
    this.periods.set(null, "ANY");
    this.periods.set("1hour", "Last hour");
    this.periods.set("24hour", "Last 24 hours");
    this.periods.set("48hour", "Last 48 hours");
    this.periods.set("7days", "Last 7 days");
    this.periodKeys = Array.from(this.periods.values());
  }

  ngOnInit() {
    this.reference =
      !!this.filters && !!this.filters["reference"]
        ? this.filters["reference"]
        : "";
    this.selectedType =
      !!this.filters && !!this.filters["transaction_type"]
        ? this.filters["transaction_type"]
        : this.types[0];
    this.selectedCondition =
      !!this.filters && !!this.filters["condition"]
        ? this.filters["condition"]
        : this.conditions[0];
    this.selectedPeriod =
      !!this.filters && !!this.filters["age"]
        ? this.periods.get(this.filters["age"])
        : this.periods.get(null);
    this.isHistory = !!this.isHistory; // False if undefined or stay the same as pass in the componentProp
  }

  applyFilter() {
    this.transactionsService.getFilters(this.isHistory).then((filters) => {
      if (this.reference) filters["reference"] = this.reference;
      else delete filters["reference"];
      if (this.selectedCondition != "ANY")
        filters["condition"] = this.selectedCondition;
      else delete filters["condition"];

      if (this.selectedType != "ANY")
        filters["transaction_type"] = this.selectedType;
      else delete filters["transaction_type"];

      if (this.selectedPeriod != "ANY") {
        let arr = Array.from(this.periods.keys()).find(
          (key) => this.periods.get(key) === this.selectedPeriod
        );
        if (arr) filters["age"] = arr;
      } else delete filters["age"];

      this.transactionsService.setFilters(filters, this.isHistory).then(() => {
        this.modalCtrl.dismiss(filters);
      });
    });
  }

  resetFilter() {
    this.selectedType = this.types[0];
    this.reference = "";
    this.selectedCondition = this.conditions[0];
    this.selectedPeriod = this.periods.get(null);
  }

  closeFilterModal() {
    this.modalCtrl.dismiss(this.filters);
  }
}
